(function () {
  function splitName(full) {
    full = (full || "").trim();
    if (!full) return { first: "", last: "" };
    var parts = full.split(/\s+/);
    return { first: parts.shift(), last: parts.join(" ") };
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;

      var consent = form.querySelector('input[id^="ai-contact-accepts-marketing-"]');
      if (!consent || !consent.checked) return;

      var id = consent.id.replace("ai-contact-accepts-marketing-", "");

      var emailEl = document.getElementById("ai-contact-email-" + id);
      var nameEl = document.getElementById("ai-contact-name-" + id);
      var phoneEl = document.getElementById("ai-contact-phone-" + id);

      if (!emailEl) return;
      var email = (emailEl.value || "").trim();
      if (!email) return;

      var nm = splitName(nameEl ? nameEl.value : "");
      var phone = phoneEl ? (phoneEl.value || "").trim() : "";
      var phoneDigits = phone.replace(/[^0-9]/g, "");

      // Build x-www-form-urlencoded payload Shopify expects for customer/newsletter submissions
      var params = new URLSearchParams();
      params.set("form_type", "customer");
      params.set("utf8", "✓");
      params.set("contact[email]", email);
      params.set("contact[first_name]", nm.first);
      params.set("contact[last_name]", nm.last);
      params.set("contact[accepts_marketing]", "true");
      params.set("contact[tags]", "newsletter,putters-contact-optin" + (phoneDigits ? (",phone_" + phoneDigits) : ""));
      if (phone) params.set("contact[phone]", phone);

      // Fire-and-forget background submit
      try {
        fetch("/contact", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
          body: params.toString(),
          credentials: "same-origin",
          keepalive: true,
        });
      } catch (err) {}
    },
    true
  );
})();
